<template>
  <div class="cqykemailAddress">
    <div class="cqykemailAddress_top">
      <h4>邮箱注册</h4>
    </div>
    <div class="cqykemailAddress_content">
      <el-form
        :model="formList"
        :rules="formRules"
        ref="formList"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="姓名" prop="name">
          <el-input v-model="formList.name" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="工号" prop="workNumber">
          <el-input v-model="formList.workNumber" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="单位" prop="company">
          <el-input v-model="formList.company" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="phoneNumber">
          <el-input v-model="formList.phoneNumber"></el-input>
        </el-form-item>
        <el-form-item label="邮箱主账号" prop="emailAccount">
          <el-input v-model="formList.emailAccount" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input
            v-model="formList.password"
            placeholder="必须包含大小写字母和数字(至少8位)"
            show-password
          ></el-input>
        </el-form-item>
        <el-form-item label="邮箱别名" prop="emailName">
          <el-input v-model="formList.emailName" placeholder="请输入邮箱别名">
            <template slot="append">{{ emailNameSuffix }}</template>
          </el-input>
        </el-form-item>

        <el-form-item label="确认密码" prop="confirmPassword">
          <el-input
            v-model="formList.confirmPassword"
            placeholder="请再次输入密码"
            show-password
          ></el-input>
        </el-form-item>
      </el-form>
      <el-button
        type="primary"
        round
        @click="submitForm('formList')"
        class="cqykBtn"
        >注册</el-button
      >
      <div class="tips">
        温馨提示：
        <span>1、师生激活邮箱时注意填写别名邮箱； </span>
        <span
          >2、邮箱密码不少于6位，同时包含大小写字母（不能是hnust等专有名词）和数字（不能是连续正序数字，不能是工号）；</span
        >
        <!-- <span
          >3、校本部教职工需要@mail.hnust.edu.cn后缀邮箱请填写“学校邮箱申请”表单，搜索路径：需先登录“门户”，再点击右上角搜索图标，搜索“学校邮箱申请”并填写。</span
        > -->
        <span>3、教职工邮箱账号为员工号@hnust.edu.cn；学生邮箱账号为学号@mail.hnust.edu.cn。</span>
      </div>
    </div>
  </div>
</template>

<script>
import request from "@/utils/request";
import { mapGetters } from "vuex";
export default {
  name: "mailRegister",
  data() {
    // 姓名验证
    // var nameCheck = (rule, value, callback) => {
    //   // var nameTest = /^[\u4E00-\u9FA5\uf900-\ufa2d·s]{2,20}$/;
    //   // if (!value) {
    //   //   return callback(new Error("姓名不能为空"));
    //   // } else if (!nameTest.test(value)) {
    //   //   return callback(new Error("姓名只能为2-4中文！"));
    //   // } else {
    //   //   callback();
    //   // }
    // };
    // 工号验证
    // var workNumberCheck = (rule, value, callback) => {
    //   // if (!value) {
    //   //   return callback(new Error("工号不能为空"));
    //   // } else if (!nameTest.test(value)) {
    //   // } else {
    //   //   callback();
    //   // }
    // };
    // 单位验证
    // var companyCheck = (rule, value, callback) => {
    //   // if (!value) {
    //   //   return callback(new Error("单位不能为空"));
    //   // } else if (!nameTest.test(value)) {
    //   // } else {
    //   //   callback();
    //   // }
    // };
    // 手机号码验证
    var phoneCheck = (rule, value, callback) => {
      var phoneTest =
        /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
      if (!value) {
        return callback(new Error("请填写您的手机号码！"));
      } else if (!phoneTest.test(value)) {
        return callback(new Error("请正确填写您的手机号码"));
      } else {
        callback();
      }
    };

    var validatePass = (rule, value, callback) => {
      // let reg = /^(?=.*[a-zA-Z])(?=.*[1-9]).{6,32}$/;
      // /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,20}$/;
      let reg = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[1-9]).{8,32}$/;

      if (value === "") {
        callback(new Error("请输入密码"));
      } else if (!reg.test(value)) {
        callback(new Error("密码不符合规定"));
      } else {
        if (this.formList.confirmPassword !== "") {
          this.$refs.formList.validateField("confirmPassword");
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.formList.password) {
        callback(new Error("两次密码不同!"));
      } else {
        callback();
      }
    };

    return {
      imgCodeId: "",
      imgCodeUrl: "",
      cqykUserName: "",
      emailNameSuffix: "",
      formList: {
        name: "",
        sex: "",
        workNumber: "",
        company: "",
        phoneNumber: "",
        password: "",
        confirmPassword: "",
        emailName: "",
        emailAccount: "",
      },
      formRules: {
        // name: [
        //   {
        //     required: true,
        //     validator: nameCheck,
        //     trigger: "blur",
        //   },
        // ],
        // password: [
        //   {
        //     validator: validatePass,
        //     trigger: "blur",
        //     required: true,
        //   },
        // ],
        // company: [
        //   {
        //     required: true,
        //     validator: companyCheck,
        //     trigger: "blur",
        //   },
        // ],
        // workNumber: [
        //   {
        //     required: true,
        //     validator: workNumberCheck,
        //     trigger: "blur",
        //   },
        // ],
        confirmPassword: [
          {
            validator: validatePass2,
            trigger: "blur",
            required: true,
          },
        ],

        phoneNumber: [
          {
            validator: phoneCheck,
            trigger: "blur",
          },
        ],
      },
    };
  },
  computed: {
    ...mapGetters(["request"]),
  },
  created() {
    // this.handleUrlInfo();
    this.handlegetInfo();
  },
  methods: {
    async submitForm() {
      let data = {
        name: this.formList.name,
        account: this.formList.workNumber,
        company: this.formList.company,
        // confirmPassword: this.formList.confirmPassword,
        password: this.formList.password,
        slaves: this.formList.emailName,
        mobile: this.formList.phoneNumber,
        gender: this.formList.sex,
        userid: this.formList.emailAccount,
      };
      await request({
        url: `https://portal-center-i.hnust.edu.cn/portalCenter/v2/personalData/bindExMail`,
        method: "post",
        headerType: "portal",
        data: data,
      }).then((res) => {
        console.log(res,'res');
        if (res.data.code == 0) {
          this.$message({
            message: "注册成功",
            type: "success",
            duration: 8000,
          });
          window.open(res.data.emailUrl)
          // this.$refs.formList.resetFields();
          // window.close();
          // window.parent.opener.location.reload();
        } else {
          this.$message({
            message: res.data.message,
            type: "warning",
            duration: 8000,
          });
        }
      });
    },
    // submitForm(formName) {
    //   // window.opener=null;
    //   // window.open('','_self');
    //   // window.close();
    //   // window.parent.opener.location.reload();
    //   console.log(this.formList.company);
    //   // "http://192.168.2.62:20001/portalCenter/v2/personalData/bindExMail"
    //   this.$refs[formName].validate((valid) => {
    //     if (valid) {
    //       this.request
    //         .post(
    //           "https://portal-center-i.hnust.edu.cn/portalCenter/v2/personalData/bindExMail",
    //           {
    //             name: this.formList.name,

    //             account: this.formList.workNumber,
    //             company: this.formList.company,
    //             // confirmPassword: this.formList.confirmPassword,

    //             password: this.formList.password,
    //             slaves: this.formList.emailName,
    //             mobile: this.formList.phoneNumber,
    //             gender: this.formList.sex,
    //             userid: this.formList.emailAccount,
    //           }
    //         )
    //         .then((res) => {
    //           console.log(res);
    //           console.log(res.data.code);
    //           console.log(this.formList.emailName);
    //           if (res.data.code == 0) {
    //             this.$message({
    //               message: "注册成功",
    //               type: "success",
    //               duration: 8000,
    //             });
    //             this.$refs.formList.resetFields();
    //             window.close();
    //             window.parent.opener.location.reload();
    //           } else {
    //             this.$message({
    //               message: res.data.message,
    //               type: "warning",
    //               duration: 8000,
    //             });
    //           }
    //         });
    //     } else {
    //       console.log("error submit!!");
    //       return false;
    //     }
    //   });
    // },
    // resetForm(formName) {
    // 	this.$refs[formName].resetFields();
    // },
    async handlegetInfo() {
      await request({
        url: `https://portal-center-i.hnust.edu.cn/portalCenter/v2/personalData/getUserInfo`,
        method: "get",
        headerType: "portal",
      }).then((res) => {
        console.log(res.data, "jinlai");
        this.formList.name = res.data.data.name;
        this.formList.sex = res.data.data.sex;
        this.formList.workNumber = res.data.data.account;
        this.formList.phoneNumber = res.data.data.phoneNumber;
        this.formList.company = res.data.data.company;
        this.formList.emailAccount = res.data.data.userid;
        let suffixInfo = res.data.data.userid;
        let suffix = suffixInfo.split("@")[1];
        this.emailNameSuffix = "@" + suffix;
      });
    },
    //获取链接后拼接参数
    handleUrlInfo() {
      let urlInfo = window.location.href;
      let urlParams = urlInfo.split("?");
      let paramData = urlParams[1].split("&");
      //   this.cqykUserName = urlParams[1].split("=")[1];
      // this.data1 = paramData[0].split('=')[1];
      // this.data2 = paramData[1].split('=')[1];
    },
    handlePassword() {
      this.formList.password.replace(/./g, "*");
      console.log("sssss");
    },
  },
};
</script>

<style lang="scss">
* {
  margin: 0;
  padding: 0;
}

.cqykemailAddress {
  // background: #e7e7e7;
  &_top {
    width: 100%;
    box-sizing: border-box;
    padding: 30px 50px;
    // background: url(../../assets/siyida/common-window-bak-title.png) no-repeat
    //   center #f4f8fc;
    background-size: cover;
    display: flex;
    align-items: center;
    background: #054fa1;

    img {
      height: 70px;
      border-right: 1px solid #c8c8c8;
      margin-right: 25px;
      padding-right: 20px;
    }

    h4 {
      font-size: 30px;
      font-weight: normal;
      margin: 0;
      color: #fff;
    }
  }

  &_content {
    // width: 25%;
    margin: 0 auto;
    padding-top: 100px;

    width: 60%;

    // display: flex;
    // flex-direction: row;
    .cqykBtn {
      margin-left: 50%;
      margin-top: 20px;
    }
    .tips {
      margin-top: 10px;
      font-size: 14px;
      color: #666;
      text-align: justify;
      display: flex;
      flex-direction: column;
    }
    .el-form {
      display: flex;
      justify-content: space-between;
      width: 100%;
      flex-wrap: wrap;
      align-items: center;

      // .cqykBtn{
      // 	width: 100%!important;
      // }
      .el-form-item {
        width: 40%;

        .el-select {
          width: 100%;
        }
      }
    }

    .title {
      display: block;
      font-size: 25px;
      text-align: left;
      padding: 10px 0;
      margin-bottom: 50px;
    }

    .el-input-group {
      // margin-bottom: 40px;

      /deep/ .el-input__inner {
        border-radius: 30px 0 0 30px;
      }

      .el-input-group__append {
        border-radius: 0 0px 0px 0;
      }
    }
  }
}
@media screen and (max-width: 1536px) {
  .cqykemailAddress_content {
    width: 80%;
  }
  .cqykemailAddress_content .el-form .el-form-item {
    width: 45%;
  }
  /deep/.cqykemailAddress_content .el-input-group {
    margin-bottom: 0px !important;
  }
}
</style>
